module.exports = __webpack_public_path__ + "static/media/ni.a9faba49.png";